var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.49818,
    cy: 16.5019,
    r: 1.50063,
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74726 11.3774L12.4017 4.4381C12.8312 4.09843 13.3786 3.94453 13.9222 4.01066C17.9629 4.48496 21.0076 7.91101 21.0038 11.9795V18.9984C21.0051 20.1046 20.1093 21.0025 19.003 21.0037H4.99717C3.89089 21.0025 2.99509 20.1046 2.99634 18.9984V12.9434C2.99634 12.3345 3.27239 11.7585 3.74726 11.3774Z",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0023 21.0038H14.5012C13.9487 21.0038 13.5008 20.5559 13.5008 20.0033V19.7532C13.5008 18.5101 14.5086 17.5023 15.7517 17.5023V17.5023C16.9949 17.5023 18.0027 18.5101 18.0027 19.7532V20.0033C18.0027 20.5559 17.5548 21.0038 17.0023 21.0038Z",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.004 11.9999L3.23413 12",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2502 12H14.251C14.8035 12 15.2514 12.4479 15.2514 13.0004V13.0004C15.2514 14.1054 14.3556 15.0013 13.2506 15.0013V15.0013C12.1456 15.0013 11.2498 14.1054 11.2498 13.0004V13.0004C11.2498 12.4479 11.6977 12 12.2502 12Z",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeals);
export default __webpack_public_path__ + "static/media/meals.409b3eccfd521e18894093923b1904fb.svg";
export { ForwardRef as ReactComponent };